import type { Section } from '@/types'

// La section d'une page se lit directement dans son chemin, sans dependre du
// contenu charge : les pages professionnelles vivent sous /pro/, les pages
// d'interventions locales sous /interventions/. L'habillage (theme sombre PRO,
// theme clair standard/zone) en decoule cote layout (header, footer, page).
export function sectionForPath(path: string): Section {
  const p = path || '/'
  if (p === '/pro' || p.startsWith('/pro/')) return 'pro'
  if (p.startsWith('/interventions/')) return 'zone'
  return 'standard'
}

export function isProPath(path: string): boolean {
  return sectionForPath(path) === 'pro'
}
